import { createFeatureSelector } from '@ngrx/store';
import { FeatureState } from './state';

export const featureKey = 'dialogsFeature';

export const selectFeatureState = createFeatureSelector<FeatureState>(featureKey);
